module.exports = __webpack_public_path__ + "static/shelbi-afee07e67776046ca5155829bbd28991.jpeg";